import Anchor from './anchor';
import AnchorLink from './anchor-link';
var DefaultAnchor = Anchor;
DefaultAnchor.Link = AnchorLink;
export default DefaultAnchor;
//# sourceMappingURL=index.js.map